import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IconArrowUpRight } from "@tabler/icons-react";
import { fadeUp } from "./animations";

export default function InstituteCTA() {
  return (
    <section className="bg-white py-20 sm:py-24">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="
          mx-auto
          max-w-4xl
          px-5
          text-center
          sm:px-8
        "
      >
        <p
          className="
            text-xs
            font-bold
            uppercase
            tracking-[0.2em]
            text-[#55aef3]
          "
        >
          Start Learning
        </p>

        <h2
          className="
            merriweather
            mt-5
            text-3xl
            font-black
            tracking-[-0.04em]
            sm:text-4xl
            lg:text-[52px]
          "
        >
          Build skills for
          <br />
          <span className="text-[#55aef3]">your next opportunity.</span>
        </h2>

        <p
          className="
            mx-auto
            mt-5
            max-w-2xl
            text-[16px]
            leading-7
            text-neutral-600
          "
        >
          Choose the course that matches your career goals and start your
          practical learning journey with WE3X Institute.
        </p>

        <Link
          to="/contact"
          className="
            mt-8
            inline-flex
            items-center
            gap-2
            rounded-[8px]
            bg-[#151515]
            px-7
            py-3.5
            text-sm
            font-bold
            text-white
            transition-all
            hover:-translate-y-1
            hover:bg-[#55aef3]
          "
        >
          Enquire About Courses
          <IconArrowUpRight size={17} />
        </Link>
      </motion.div>
    </section>
  );
}
